import React from 'react';
import { Card } from '../ui/card';
import { LayoutGrid } from 'lucide-react';
import { fmtDuracion } from './actividadUtils';

export const TopSecciones = ({ items }) => {
  const max = Math.max(1, ...items.map((i) => i.vistas));
  return (
    <Card className="p-5 bg-white border-slate-200" data-testid="act-top-secciones">
      <h3 className="text-base font-bold text-slate-800 flex items-center gap-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
        <LayoutGrid size={16} className="text-teal-700" /> Secciones más usadas
      </h3>
      {!items.length && <p className="text-sm text-slate-400 mt-6 text-center">Todavía no hay pantallas registradas.</p>}
      <ul className="mt-3 space-y-2.5 max-h-64 overflow-y-auto pr-1">
        {items.map((s, i) => (
          <li key={s.seccion} data-testid={`act-top-seccion-${i}`}>
            <div className="flex items-baseline justify-between gap-2 text-sm">
              <span className="font-semibold text-slate-700 truncate" title={s.modulo ? `${s.modulo} · ${s.seccion}` : s.seccion}>{s.seccion}</span>
              <span className="text-xs text-slate-400 tabular-nums shrink-0">{s.vistas} · {fmtDuracion(s.tiempo_seg)} · {s.usuarios} usr</span>
            </div>
            <div className="mt-1 h-1.5 rounded-full bg-slate-100 overflow-hidden">
              <div className="h-full rounded-full bg-teal-600 transition-[width] duration-700" style={{ width: `${(s.vistas / max) * 100}%` }} />
            </div>
          </li>
        ))}
      </ul>
    </Card>
  );
};

export default TopSecciones;
